export const FLOW_STEPS = {
    연구비: [
        { label: "품의서 작성", icon: "mdi-file-document-edit" },
        { label: "결재 승인", icon: "mdi-check-decagram" },
        { label: "구매실행", icon: "mdi-cart" },
        { label: "물품수령", icon: "mdi-package-variant" },
        { label: "입고/검수", icon: "mdi-warehouse" },
    ],
    연구비_발주: [
        { label: "품의서 작성", icon: "mdi-file-document-edit" },
        { label: "결재 승인", icon: "mdi-check-decagram" },
        { label: "발주서", icon: "mdi-file-send" },
        { label: "입고/검수", icon: "mdi-warehouse" },
    ],
    법인비_현금: [
        { label: "품의서 작성", icon: "mdi-file-document-edit" },
        { label: "결재 승인", icon: "mdi-check-decagram" },
        { label: "발주서 작성", icon: "mdi-file-send" },
        { label: "발주 확정", icon: "mdi-check-bold" },
        { label: "지출결의서", icon: "mdi-cash-register" },
        { label: "결제 + 입고", icon: "mdi-credit-card" },
        { label: "완료", icon: "mdi-flag-checkered" },
    ],
    법인비_카드: [
        { label: "간소화 품의서", icon: "mdi-file-document-edit" },
        { label: "지출결의서", icon: "mdi-cash-register" },
        { label: "결제", icon: "mdi-credit-card" },
        { label: "물품수령", icon: "mdi-package-variant" },
        { label: "입고/검수", icon: "mdi-warehouse" },
    ],
};
export function getFlowKey(costType, paymentMethod, hasOrder) {
    if (costType === "연구비")
        return hasOrder ? "연구비_발주" : "연구비";
    return `법인비_${paymentMethod ?? "현금"}`;
}
